"use client"
import * as React from "react"
import Image from "next/image"
import Marquee from "react-fast-marquee"
import { GLOBAL_PATHS } from "@djotta/utils"
import { useTranslations } from "@/components/I18nProvider"

/**
 * Ce composant permet d'afficher et d'organiser les informations d'un utilisateur
 * @name PartnersCarousel
 */
const PartnersCarousel: React.FC = () => {
  const t = useTranslations("projects")

  const imageSize = 48
  const projects = [
    {
      title: "STD S.A.",
      img: `${GLOBAL_PATHS.PARTNERS}std.webp`,
      width: imageSize,
      height: imageSize,
    },
    {
      title: "One Health",
      img: `${GLOBAL_PATHS.PARTNERS}One Health Data Graphic.png`,
      width: 56,
      height: imageSize,
    },
    {
      title: "DGSN",
      img: `${GLOBAL_PATHS.PARTNERS}logo-dgsn.png`,
      width: imageSize,
      height: imageSize,
    },
    {
      title: "Picardi Mall",
      img: `${GLOBAL_PATHS.PARTNERS}picardi-mall-logo-removebg-preview.png`,
      width: imageSize,
      height: imageSize,
    },
    {
      title: "Douanes Camerounaises",
      img: `${GLOBAL_PATHS.PARTNERS}douane-300x300.png`,
      width: imageSize,
      height: imageSize,
    },
    {
      title: "PeFi",
      img: `${GLOBAL_PATHS.PARTNERS}pefi-logo.webp`,
      width: imageSize,
      height: imageSize,
    },
  ]

  return (
    <React.Suspense fallback={<div className="h-20 animate-pulse bg-muted rounded-xl" />}>
      <section id="project-section" className="py-6 md:pb-1 px-4 lg:px-12">
        <Marquee speed={75} pauseOnHover gradient gradientColor="hsl(var(--background))" gradientWidth={50}>
          {projects.map((project, index) => (
            <div
              key={index}
              className="mx-8 flex items-center justify-center py-4"
            >
              <Image
                alt={project.title}
                src={project.img}
                width={project.width}
                height={project.height}
                className="grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all duration-300"
              />
            </div>
          ))}
        </Marquee>
      </section>
    </React.Suspense>
  )
}

export default PartnersCarousel
